import axios from "axios";
import {
  type AddedUsers,
  type CompletedUsers,
  type StartedUsers,
  type ActiveUsers,
  type ConsumedLicenses,
  type EmailActivity,
  type EmailPerformance,
} from "../types/overview";
import { type OwnerPacksLicensing, type PackLicenses } from "../types/packs";
import { processPerformanceParams } from "utils/queryUtils";
import { type SpPackReportFilter } from "../Packs/SolutionProvider/SpPackReport";

export const addedUsersEndpoint = "/api/reports/flows/added-users";
export const completedUsersEndpoint = "/api/reports/flows/completed";
export const startedUsersEndpoint = "/api/reports/flows/started";
export const activeUsersEndpoint = "/api/reports/users/active";
export const consumedLicensesEndpoint = "/api/reports/packs/consumed-licenses";
export const emailActivityEndpoint = "/api/reports/communications/email-activity";
export const emailPerformanceEndpoint = "/api/reports/communications/email-performance";

export const packPerformanceEndpoint = "/api/reports/v1/licenses/partner/packs";
export const packCustomersEndpoint = "api/reports/v1/licenses/partner/packs/customers";

let ownerPacksLicensingAbortController = new AbortController();

export const reportingDataService = {
  getAddedUsers() {
    return axios.get<AddedUsers[]>(addedUsersEndpoint);
  },
  getCompletedUsers() {
    return axios.get<CompletedUsers[]>(completedUsersEndpoint);
  },
  getStartedUsers() {
    return axios.get<StartedUsers[]>(startedUsersEndpoint);
  },
  getActiveUsers() {
    return axios.get<ActiveUsers[]>(activeUsersEndpoint);
  },
  getConsumedLicenses() {
    return axios.get<ConsumedLicenses[]>(consumedLicensesEndpoint);
  },
  getEmailActivity() {
    return axios.get<EmailActivity[]>(emailActivityEndpoint);
  },
  getEmailPerformance() {
    return axios.get<EmailPerformance>(emailPerformanceEndpoint);
  },
  // For BSI / Partners
  getOwnerPacksLicensing(filter: SpPackReportFilter) {
    ownerPacksLicensingAbortController.abort();
    ownerPacksLicensingAbortController = new AbortController();
    return axios.get<OwnerPacksLicensing[]>(packPerformanceEndpoint, {
      signal: ownerPacksLicensingAbortController.signal,
      params: { ...filter },
      paramsSerializer: processPerformanceParams,
    });
  },
  // For drilldown
  getPackLicenses(packId: number, filter: SpPackReportFilter) {
    return axios.get<PackLicenses[]>(packCustomersEndpoint, {
      params: { packId, ...filter },
      paramsSerializer: processPerformanceParams,
    });
  },
};
